
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/detail/[uid]",
      function () {
        return require("private-next-pages/guide/detail/[uid]/index.tsx");
      }
    ]);
  